import { render } from "./index-valuation-table.vue?vue&type=template&id=af333536&scoped=true"
import script from "./index-valuation-table.vue?vue&type=script&lang=ts"
export * from "./index-valuation-table.vue?vue&type=script&lang=ts"

import "./index-valuation-table.vue?vue&type=style&index=0&id=af333536&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-af333536"

export default script